import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Layout,
  Image,
  Popover,
  Menu,
  Message,
  Modal,
  Spin,
} from "@arco-design/web-react";
// import logo from "@/assets/images/tag_logo.png";
import {
  IconClose,
  IconLeft,
  IconRefresh,
  IconRight,
} from "@arco-design/web-react/icon";
import "./Layout.less";
import KehuImg from "@/assets/images/kehuduan-min.png";
import JZYX from "@/assets/images/jzyx-min.png";
import MenuLayout from "./components/MenuLayout";
import logout_icon from "@/assets/images/logout.png";
import ClientTabs from "@/stores/clientTabStore";
import { Outlet, useMatches, useLocation, useNavigate } from "react-router-dom";
import AuthTab from "@/components/AuthTab";
import { routes } from "@/router/index";
import store from "@/stores/authTabStore";
import { observer } from "mobx-react-lite";
import { getUserAvatarUrl, getUserInfo } from "@/services/common";
import { v4 as uuidv4 } from "uuid";
import douyin from "@/assets/images/douyin.png";
import kuai_shou from "@/assets/images/kuai_shou.png";
import shi_pin_hao from "@/assets/images/shi_pin_hao.png";
import use from "@/assets/images/use.png";
import update from "@/assets/images/update.png";

import xiao_hong_shu from "@/assets/images/xiao_hong_shu.png";
import zoom_max from "@/assets/images/zoom_max.png";
import zoom_min from "@/assets/images/zoom_min.png";
import minimize from "@/assets/images/minimize.png";
import close from "@/assets/images/close.png";
import _ from "lodash";
import { Tabs, Typography } from "@arco-design/web-react";
import { getAuthVersion, getConfig } from "@/services/authorization";
import Cookies from "js-cookie";
import ClientUpdate from "@/stores/clientUpdate";
import AgentList from "@/components/AgentList";
import { agentOneLogin } from "@/services/login";
import AgentStore from "@/stores/agentLogin";
import Notice from "@/components/Notice";
import jinritoutiaoImg from "@/assets/images/jinritoutiao.png";
import baijiahaoImg from "@/assets/images/baijiahao.png";
import blibliImg from "@/assets/images/blibli.png";
const Sider = Layout.Sider;
const Header = Layout.Header;
const Content = Layout.Content;
const MenuItem = Menu.Item;
const TabPane = Tabs.TabPane;
const Layouts = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMaximized, setIsMaximized] = useState(false);
  const [visible, setVisible] = useState(false);
  const [versionLoading, setVersionLoading] = useState<boolean>(false);
  const [version, setVersion] = useState<string>("");
  const [changeLoading, setChangeLoading] = useState<boolean>(false);
  const agentRef = useRef(null);
  const [userInfo, setUserInfo] = React.useState({
    avatar_color: "",
    nickname: "",
    avatar: "",
  });
  const [avatar, setAvatar] = React.useState("");
  const isContinuousScrollingRef = useRef(false);
  const [currentDirection, setCurrentDirection] = useState(0); // 当前滚动方向
  const [isAtLeft, setIsAtLeft] = useState(true); // 是否已经滚动到最左边
  const [isAtRight, setIsAtRight] = useState(false); // 是否已经滚动到最右边
  const contentWrapperRef = useRef(null);
  const scrollAmount = 160; // 每次滚动的距离
  const continuousScrollSpeed = 10; // 连续滚动时的速度
  const scrollTimeoutRef = useRef(null); // 用于存储定时器
  const [changeVisble, setChangeVisble] = useState<boolean>(false);
  const chickenSoup = [
    "创意火花绽放，勇敢探索，成就独特璀璨作品",
    "嘿~ 快来！在这里实现你的无限创意",
    "多用AI，让你的作品成为独一无二的璀璨星辰",
    "每一个灵感都是宝藏",
    "大胆想象，让你的作品成为惊艳时光的艺术传奇",
    "用心剪辑每一帧，以帧为笔，绘出绚丽画卷",
    "剪辑视频，那就是在雕琢时光",
    "沉浸剪辑工作，用影像传递温暖力量",
    "灵感如星，照亮创意的浩瀚天空",
    "AI 赋能，高效便捷，快来体验未来新趋势",
    "借助 AI 之力，轻松解决难题，畅享智慧之旅",
    "拥抱 AI，让 AI 成为你的得力助手",
  ];
  const [randomTitle, setRandomTitle] = useState("");
  const [agentInfo, setAgentInfo] = useState<any>();
  const randomIndex = Math.floor(Math.random() * chickenSoup.length);
  useEffect(() => {
    setRandomTitle(chickenSoup[randomIndex]);
  }, []);
  const handleToMain = () => {
    navigate("/");
  };
  const handleMinimize = () => {
    window.electron.ipcRenderer.windowControl.minimize();
  };

  const handleMaximize = () => {
    window.electron.ipcRenderer.windowControl.maximize();
  };

  const handleClose = () => {
    window.electron.ipcRenderer.windowControl.close();
  };
  // 连续滚动（长按）
  const continuousScroll = (direction) => {
    if (isContinuousScrollingRef.current && contentWrapperRef.current) {
      contentWrapperRef.current.scrollLeft += direction * continuousScrollSpeed;
      requestAnimationFrame(() => continuousScroll(direction));
    }
  };
  const handleMouseDown = (direction) => {
    setCurrentDirection(direction);

    // 设置定时器，200ms 后认为是长按
    scrollTimeoutRef.current = setTimeout(() => {
      // setIsContinuousScrolling(true);
      isContinuousScrollingRef.current = true;
      continuousScroll(direction);
    }, 200);
  };
  // 离散滚动（短按）
  const discreteScroll = (direction) => {
    if (contentWrapperRef.current) {
      contentWrapperRef.current.scrollBy({
        left: direction * scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleMouseUpOrLeave = () => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
      // 如果长按未触发，则执行一次离散滚动
      if (!isContinuousScrollingRef.current) {
        discreteScroll(currentDirection);
      }
    }
    isContinuousScrollingRef.current = false;
  };
  // 更新按钮的显隐
  const updateButtonVisibility = () => {
    const contentWrapper = contentWrapperRef.current;
    console.log("====================================");
    console.log(contentWrapper.scrollWidth);
    console.log(contentWrapper.clientWidth);

    console.log("====================================");
    const atLeft = contentWrapper.scrollLeft === 0;
    const atRight =
      contentWrapper.scrollLeft ===
      contentWrapper.scrollWidth - contentWrapper.clientWidth;

    setIsAtLeft(atLeft);
    setIsAtRight(atRight);
  };
  const checkAppleSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    // 使用类型断言来绕过类型检查
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return true;
    } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      return true;
    } else {
      return false;
    }
  };
  const getPlatform = () => {
    const actionMap = {
      1: {
        src: "https://creator.douyin.com/",
        icon: douyin,
      },
      2: "",
      3: {
        src: "https://channels.weixin.qq.com/",
        icon: shi_pin_hao,
      },
      4: {
        src: "https://creator.xiaohongshu.com/",
        icon: xiao_hong_shu,
      },
      6: {
        src: "https://www.bilibili.com/",
        icon: blibliImg,
      },
      7: {
        src: "https://mp.toutiao.com/auth/page/login",
        icon: jinritoutiaoImg,
      },
      8: {
        src: "https://baijiahao.baidu.com/builder/theme/bjh/login",
        icon: baijiahaoImg,
      },
    };
    return actionMap[store.platform];
  };
  // 监听滚动事件
  useEffect(() => {
    const contentWrapper = contentWrapperRef.current;
    if (!contentWrapper) return;
    const handleScroll = () => {
      updateButtonVisibility();
    };
    contentWrapper.addEventListener("scroll", handleScroll);
    // 初始化时检查按钮显示状态
    updateButtonVisibility();
    // 清理监听器
    return () => {
      contentWrapper.removeEventListener("scroll", handleScroll);
    };
  }, [ClientTabs.tabsActiveKey]);
  useEffect(() => {
    if (userInfo.avatar) {
      getUserAvatarUrl(userInfo.avatar)
        .then((res) => {
          setAvatar(res.data.url);
        })
        .catch((e) => {
          console.log("头像获取失败");
        });
    } else {
      setAvatar(undefined);
    }
  }, [userInfo.avatar]);
  useEffect(() => {
    const result = routes[1]?.children?.find(
      (item) => location.pathname.replace("/matrix/", "") === item.path
    );
    store.updateShowTab(result?.showTab);
  }, [location.pathname]);

  useEffect(() => {
    getUserInfo().then((res) => {
      setUserInfo(res.data);
    });
  }, []);
  const [logo, setLogo] = useState("");
  useEffect(() => {
    // const obj = JSON.parse(localStorage.getItem('AppStore') || '{}')
    // setLogo(obj?.config?.web?.app?.collapse_logo)
  }, []);
  useEffect(() => {
    const path = ClientTabs.tabs.find(
      (v) => v.key == ClientTabs.tabsActiveKey
    ).path;
    if (path !== "/matrix/mandate")
      navigate(
        ClientTabs.tabs.find((v) => v.key == ClientTabs.tabsActiveKey).path
      );
  }, [ClientTabs.tabsActiveKey]);
  const handleOnClickMenu = (e) => {
    localStorage.removeItem("Token");
    localStorage.removeItem("agent_token");
    localStorage.clear();
    window.location.href = `/login?next=${window.location.pathname + window.location.search}`;
  };
  const handleGetVersion = async () => {
    if (window.electron.ipcRenderer.getVersion) {
      const version = await window.electron.ipcRenderer.getVersion();
      ClientUpdate.setVersion(version);
    }
  };
  const handleGetAuthVersion = async () => {
    setVersionLoading(true);
    const res = await getAuthVersion(version);

    setVersionLoading(false);
    if (res && res.version !== version) {
      ClientUpdate.setUpdateStatus(true);
      ClientUpdate.setVersion(res.version);
      ClientUpdate.setUpdateInfo(res);
      ClientUpdate.setIsPromptly(true);
    }
  };
  const teamMenu = () => {
    return (
      <>
        <div style={{ display: "flex", alignItems: "center" }}>
          <p className="menu-user">{userInfo?.nickname}</p>
          {AgentStore?.agent_info?.token ? (
            <p
              className="change-menu-user"
              onClick={() => {
                setChangeVisble(true);
              }}
            >
              切换
            </p>
          ) : (
            <></>
          )}
        </div>
        <Menu
          mode="pop"
          onClickMenuItem={(e) => {
            switch (e) {
              case "1":
                ClientTabs.setIsShowDoc(true);
                break;
              case "2":
                sessionStorage.removeItem("next_update");
                Cookies.remove("ClientSkip");
                handleGetAuthVersion();
                break;
              case "3":
                localStorage.removeItem("Token");
                localStorage.removeItem("AgentLogin");
                localStorage.clear();
                window.location.href = `/login?next=${window.location.pathname + window.location.search}`;
                break;
              default:
                break;
            }
            if (e !== "2") {
              setVisible(false);
            }
          }}
        >
          <MenuItem key="1">
            <Image
              style={{
                marginRight: "10px",
                marginBottom: "4px",
              }}
              src={use}
              width={14}
              preview={false}
            />
            使用教程
          </MenuItem>
          <MenuItem key="2">
            <div style={{ display: "flex", alignItems: "center" }}>
              {versionLoading ? (
                <>
                  <Spin />
                  <p>版本检查中</p>
                </>
              ) : (
                <>
                  <Image
                    style={{
                      marginRight: "5px",
                      marginBottom: "4px",
                    }}
                    src={update}
                    width={14}
                    preview={false}
                  />
                  <p>版本更新</p>
                </>
              )}
            </div>
          </MenuItem>
          <MenuItem key="3">
            <Image
              style={{
                marginRight: "10px",
                marginBottom: "4px",
              }}
              src={logout_icon}
              width={14}
              preview={false}
            />
            退出登录
          </MenuItem>
        </Menu>
      </>
    );
  };
  const getClientVersion = async () => {
    const res = await window?.electron?.ipcRenderer?.getVersion();
    setVersion(res);
  };
  useEffect(() => {
    // 监听主进程传来的窗口状态变化
    if (window && window.electron) {
      window.electron.ipcRenderer.windowStateChanged((state) => {
        setIsMaximized(state);
      });

      handleGetVersion();
      getClientVersion();
    }

    // 清理事件监听器
    return () => {
      if (window && window.electron) {
        window.electron.ipcRenderer.removeListener(
          "window-state-changed",
          () => {
            //
          }
        );
        window.electron.ipcRenderer.removeListener("window-video-auth", () => {
          //
        });
      }
    };
  }, []);

  const content = () => {
    return (
      <Menu mode="pop" onClickMenuItem={(e) => handleOnClickMenu(e)}>
        <MenuItem key="1">
          <div className="logo-out">
            <Image
              style={{ marginRight: "5px", marginBottom: "2px" }}
              src={logout_icon}
              width={14}
              preview={false}
            ></Image>
            <div>退出登录</div>
          </div>
        </MenuItem>
      </Menu>
    );
  };

  return (
    <div className="pages-layout">
      <Modal
        style={{
          overflow: "hidden",
          width: 566,
          height: 620,
        }}
        visible={changeVisble}
        footer={null}
        closeIcon={<IconClose fontSize={18} />}
        onCancel={() => setChangeVisble(false)}
      >
        <div className="change-modal">
          <h1>客户账号切换</h1>
          <div className="agent-list-title-change">
            <span>当前登录账号:</span>
            <div>{userInfo?.nickname?.slice(0, 1)}</div>
            <p>{userInfo?.nickname}</p>
          </div>
          <AgentList
            type={2}
            handleChange={(row) => {
              setAgentInfo(row);
            }}
            renderProps={(e) => (agentRef.current = e)}
          />
          <Button
            loading={changeLoading}
            type="primary"
            disabled={!agentInfo?.uuid}
            className="change-btn"
            onClick={async () => {
              const res = await agentOneLogin({
                uuid: agentInfo?.uuid,
              });
              if (res.code === 0) {
                localStorage.setItem("Token", res.data.token);
                console.log("确认切换token", res.data.token);
                AgentStore.setAgentTeamId(agentInfo.id);
                // navigate(0)
                setChangeLoading(true);
                getUserInfo()
                  .then((res) => {
                    setUserInfo(res.data);
                    setChangeVisble(false);
                    navigate("/matrix?st=" + Date.now(), {
                      replace: true,
                    });
                    // agentRef.current.getList()
                    // window.location.reload();
                  })
                  .finally(() => {
                    setChangeLoading(false);
                  });
              }
            }}
          >
            确认切换
          </Button>
        </div>
      </Modal>
      <Modal
        style={{
          overflow: "hidden",
          width: 800,
          height: 600,
        }}
        visible={ClientTabs.isShowDoc}
        footer={null}
        closeIcon={<IconClose fontSize={25} />}
        onCancel={() => ClientTabs.setIsShowDoc(false)}
      >
        <iframe
          src={ClientTabs.configUrl}
          style={{
            width: 800,
            height: 660,
            display: "block",
            border: "none",
            position: "absolute",
            top: -63,
            left: 0,
          }}
        />
      </Modal>
      {ClientTabs.isClient ? null : (
        <div className="header">
          <div className="header-left">
            <Image
              preview={false}
              width={39}
              height={35}
              onClick={handleToMain}
              className="logo-img"
              src={AgentStore?.appConfig?.web?.app?.collapse_logo}
              alt=""
            />
            <img
              className="logo-title"
              style={{ marginRight: "24px" }}
              src={JZYX}
            />
            <div className="header-desc">{randomTitle}</div>
          </div>
          <div className="header-right">
            <Popover
              position="br"
              popupVisible={visible}
              onVisibleChange={() => {
                setVisible(!visible);
              }}
              trigger={"hover"}
              content={content()}
            >
              <div
                className="upload-box"
                style={{
                  background: avatar ? "" : userInfo?.avatar_color,
                }}
              >
                {avatar ? (
                  <img
                    style={{
                      borderRadius: "50%",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "top",
                    }}
                    src={avatar}
                    alt=""
                  />
                ) : (
                  userInfo?.nickname && (
                    <div className="upload-box-text">
                      {userInfo?.nickname?.slice(-2)}
                    </div>
                  )
                )}
              </div>
            </Popover>
          </div>
        </div>
      )}

      <div className="main">
        <div className="main-menu">
          <MenuLayout />
        </div>

        {ClientTabs.isClient ? (
          <Tabs
            style={{ flex: 1 }}
            activeTab={`${ClientTabs.tabsActiveKey}`}
            renderTabHeader={(props: any) => {
              const { activeTab, paneChildren } = props;
              return (
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    position: "relative",
                  }}
                >
                  <div className="clent-tabs">
                    <div
                      className={`clent-scroll-left ${isAtLeft ? "hidden" : ""}`}
                      onMouseDown={() => handleMouseDown(-1)}
                      onMouseUp={handleMouseUpOrLeave}
                      onMouseLeave={handleMouseUpOrLeave}
                    >
                      <IconLeft />
                    </div>
                    <div ref={contentWrapperRef} className="account-wrapper">
                      {paneChildren.map((item, index) => {
                        const v = ClientTabs.tabs.find(
                          (v) => v.key == item.key
                        );
                        return (
                          <div
                            className={`clent-item ${item.key == activeTab ? "clent-active" : ""}
               ${ClientTabs.tabs[ClientTabs.tabs.findIndex((v) => v.key == activeTab) - 1]?.key == item.key ? "clent-active-prev" : ""}
             ${ClientTabs.tabs[ClientTabs.tabs.findIndex((v) => v.key == activeTab) + 1]?.key == item.key ? "clent-active-next" : ""}`}
                            onClick={() => {
                              ClientTabs.setActivePath(item.key);
                            }}
                            style={{
                              position: index == 0 ? "absolute" : "unset",
                              marginLeft: index == 1 ? 153 : 0,
                            }}
                            key={index}
                          >
                            {v?.icon ? (
                              <img src={v.icon} width={20} alt="" />
                            ) : (
                              <></>
                            )}
                            <p
                              style={{ paddingLeft: index === 0 ? 6 : 0 }}
                              className="clent-text"
                            >
                              {item.props.title}
                            </p>
                            <div className="clent-close-icon">
                              <IconClose
                                fontSize={16}
                                style={{
                                  marginRight: 9,
                                  display: index === 0 ? "none" : "block",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  ClientTabs.removeTab(item.key);
                                }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    className={`clent-scroll-right ${isAtRight ? "hidden" : ""}`}
                    onMouseDown={() => handleMouseDown(1)}
                    onMouseUp={handleMouseUpOrLeave}
                    onMouseLeave={handleMouseUpOrLeave}
                  >
                    <IconRight />
                  </div>
                  <div
                    className={`residue-space`}
                    style={{
                      borderRadius:
                        ClientTabs.tabsActiveKey ===
                          ClientTabs.tabs[ClientTabs.tabs.length - 1].key &&
                        isAtRight
                          ? "0 0 0 15px"
                          : 0,
                    }}
                  ></div>
                  <div
                    style={{
                      background: "#f3f4f7",
                      height: 46,
                      display: "flex",
                      alignItems: "center",
                      padding: "0 18px",
                    }}
                  >
                    <div style={{ marginRight: 20 }}>
                      <Notice />
                    </div>
                    <IconRefresh
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        window.location.reload();
                      }}
                    />
                  </div>
                  <div className="clent-user">
                    <Popover
                      popupVisible={visible}
                      onVisibleChange={() => {
                        setVisible(!visible);
                      }}
                      trigger={"hover"}
                      content={
                        <div className="user-tool">
                          <div>{teamMenu()}</div>
                        </div>
                      }
                    >
                      <div
                        className="user-avatar"
                        style={{
                          background: avatar ? "" : userInfo?.avatar_color,
                        }}
                      >
                        {avatar ? (
                          <img
                            style={{
                              borderRadius: "50%",
                              width: 30,
                              height: 30,
                              objectFit: "cover",
                              objectPosition: "top",
                            }}
                            src={avatar}
                            alt=""
                          />
                        ) : (
                          userInfo?.nickname && (
                            <div className="clent-text">
                              {userInfo?.nickname?.slice(-2)}
                            </div>
                          )
                        )}
                        <div
                          className="clent-live"
                          style={{
                            background: ClientTabs.isLive
                              ? "#00B42A"
                              : "#cccccc",
                          }}
                        ></div>
                      </div>
                    </Popover>
                  </div>
                  <div
                    className="clent-tool"
                    style={{ display: checkAppleSystem() ? "none" : "flex" }}
                  >
                    <div onClick={handleMinimize}>
                      <img src={minimize} alt="" />
                    </div>
                    <div onClick={handleMaximize}>
                      <img src={isMaximized ? zoom_min : zoom_max} alt="" />
                    </div>
                    <div onClick={handleClose}>
                      <img src={close} alt="" />
                    </div>
                  </div>
                  {checkAppleSystem() ? (
                    <div
                      style={{
                        width: 20,
                        background: "#F3F4F7",
                        height: 46,
                      }}
                    ></div>
                  ) : (
                    <></>
                  )}
                </div>
              );
            }}
          >
            {ClientTabs.tabs.map((item, index) => (
              <TabPane
                key={item.key}
                title={item.title}
                style={{ height: "100%" }}
              >
                <div style={{ display: "flex", height: "calc(100% - 58px)" }}>
                  <div
                    className="matrix-content"
                    style={{
                      marginTop: ClientTabs.isClient ? 0 : 12,
                      marginLeft: 16,
                    }}
                  >
                    {store.showTab && <AuthTab />}
                    {store.activeRoute === "/matrix/helperAuth" &&
                      ClientTabs.tabs.find(
                        (v) => v.key == ClientTabs.tabsActiveKey
                      )?.path !== "/matrix/mandate" && (
                        <Button
                          onClick={() => {
                            console.log(store.platform, getPlatform());

                            const client_uid = uuidv4();
                            if (ClientTabs.isClient) {
                              ClientTabs.addTab({
                                title: "账号授权",
                                path: "/matrix/mandate",
                                key: `${client_uid}`,
                                src: getPlatform().src,
                                icon: getPlatform().icon,
                                platform: store.platform,
                                isFinite: false,
                                content: `<div id="${client_uid}" style="height: 100%; display: block;"></div>`,
                              });
                              // setTimeout(() => {

                              // });
                            } else {
                              store.updateAuthModal(true);
                            }
                          }}
                          className="auth-btn"
                          type="primary"
                          icon={
                            !ClientTabs.isClient ? (
                              <Image
                                preview={false}
                                style={{ marginBottom: "2px" }}
                                src={KehuImg}
                                width={20}
                                height={22}
                              />
                            ) : (
                              <></>
                            )
                          }
                        >
                          {ClientTabs.isClient ? "新增授权" : "客户端授权"}
                        </Button>
                      )}
                    {item.content ? (
                      <div
                        dangerouslySetInnerHTML={{ __html: item.content }}
                        style={{ flex: 1 }}
                      />
                    ) : (
                      <Outlet />
                    )}
                  </div>
                </div>
              </TabPane>
            ))}
          </Tabs>
        ) : (
          <div className="matrix-content">
            {store.showTab && (
              <div style={{ paddingTop: "10px" }}>
                {" "}
                <AuthTab />{" "}
              </div>
            )}
            <Outlet />
          </div>
        )}
      </div>
    </div>
  );
};
export default observer(Layouts);
